const aboutContent = {
    introText: `Design with Curves is more than a competition — it's a call to rethink how we design, shape, and experience space. Rooted in the exploration of fluid architecture and complex geometries, this initiative challenges conventional architectural norms and invites a new wave of designers to experiment with the extraordinary.

We believe that curves, fluidity, and digital precision are not just aesthetic choices — they are design philosophies that reflect movement, adaptability, and innovation. Through this competition, we provide a platform for students, young architects, and emerging creatives to break away from rigid forms and linear thinking, and to explore the expressive potential of parametric and organic design.`,
    closingText: "- Morphologic team",
  };
// src/config/aboutContent.js

const aboutContentpg = {
    whoWeAre: {
      heading: "Who We Are?",
      text: `We are a collective of designers, educators, and visionaries committed to reshaping the future of architecture through bold experimentation and fresh perspectives. Our mission is to empower students and emerging creatives by providing a platform where unconventional ideas, parametric thinking, and fluid design languages are not only welcomed—but celebrated.`,
    },
    ourVision: {
      heading: "Our Vision",
      text: `We envision a future where architecture is driven by innovation, inclusivity, and fearless creativity. A future where students and young designers are not just participants in the conversation—but leaders shaping the discourse.

Our vision is to cultivate a global platform that encourages the exploration of parametric and fluid design as tools for reimagining the built environment. By empowering the next generation to question norms, embrace digital experimentation, and push spatial boundaries, we aim to foster a culture where design is both expressive and responsive.

We see our competitions as catalysts—not just for design proposals, but for new ways of thinking. A space where emerging voices can challenge convention, test radical ideas, and discover the potential of architecture as an evolving, adaptive art form.`,
    },
    ourMission: {
      heading: "Our Mission",
      text: `Born from a desire to challenge the boundaries of traditional architecture, our competitions serve as open calls to the next generation of thinkers who are eager to explore digital tools, generative processes, and organic form-making. We believe in the power of education through experimentation, and we aim to create a global community where innovation is sparked by curiosity and nurtured through collaboration.`,
    },
  };
  // src/config/juryContent.js

const juryMembers = [
    {
        image: '/assets/jury1.png',
        caption: 'COSIMO SCOTUCCI',
        description: "SENIOR PROJECT LEADER AT MVRDV"

    },
    {
        image: '/assets/jury2.png',
        caption: 'LENKA PETRÁKOVÁ',
        description: "ASSOCIATE AT ZAHA HADID ARCHITECTS"

    },
    {
        image: '/assets/jury3.png',
        caption: 'NICOLAS TURCHI',
        description: "DIRECTOR OF NT-AR, PROFESSOR AT AUD"

    },
    {
        image: '/assets/jury4.png',
        caption: 'SEBASTIAN AMORELLI',
        description: "HEAD OF COMPUTATION AT EXTERNAL REFERENCE"

    }, 
    {
        image: '/assets/jury5.png',
        caption: 'HAZEL ÖZRENK',
        description: "SENIOR ARCHITECTURAL DESIGNER AT KETTLE COLLECTIVE"

    },
];
// src/config/content.js

const mediaPartners = [
      {
        image: '/assets/partner1.png',  // Path relative to the public folder
        alt: 'Partner 1',
      },
      {
        image: '/assets/partner2.png',  // Path relative to the public folder
        alt: 'Partner 2',
      },
    ];
// src/config/content.js

const winners = [
  {
    place: "1st Place",
    name: "Los Angeles Aerospace Technology and Culture Center", 
    prize: "Kaikang Shen",
    files: ["1.webp", "1-1.webp", "1-2.webp"]
  },
  {
    place: "2nd Place",
    name: "ASCENSO",
    prize: "Christian Schlag",
    files: ["2.webp", "2-1.webp", "2-2.webp"]
  },
  {
    place: "3rd Place",
    name: "Andong Talchum Art Center",
    prize: "Jinhyeok Hwang, Wonjun Choi, Jiwon Park",
    files: ["3.webp", "3-1.webp", "3-2.webp"]
  },
  {
    place: "Best Student Award",
    name: "Hamburg City Opera Center",
    prize: "Robin Luong",
    files: ["4.webp", "4-1.webp", "4-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "Rotterdam Cultural Center",
    prize: "Amir Ahmed",
    files: ["5.webp", "5-1.webp", "5-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "Tarang The Cultural Center",
    prize: "Rohit Singh Parmar",
    files: ["6.webp", "6-1.webp", "6-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "Waterfold",
    prize: "Tatiana Gaia",
    files: ["7.webp", "7-1.webp", "7-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "Sun Dunes",
    prize: "Aya Montasser",
    files: ["8.webp", "8-1.webp", "8-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "Shenzhen Contemporary Art Center",
    prize: "Li Peng, Yukui, Pengli",
    files: ["9.webp", "9-1.webp", "9-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "VEDY",
    prize: "Кристина Кулагина, Владимир Волков, Артём Бондарев",
    files: ["10.webp", "10-1.webp", "10-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "Flow Realm Weaving Network",
    prize: "Li Xiaotong",
    files: ["11.webp", "11-1.webp", "11-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "Byblos Cultural Center",
    prize: "Sirine Tabcheh",
    files: ["12.webp", "12-1.webp", "12-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "The Langhe Biophilic Nexus",
    prize: "Roba Youssef",
    files: ["13.webp", "13-1.webp", "13-2.webp"]
  },
  {
    place: "Honorable Mention",
    name: "Ringed City Cultural Center",
    prize: "Thach Sieu",
    files: ["14.webp", "14-1.webp", "14-2.webp"]
  }
];
  
export default {aboutContent, aboutContentpg, juryMembers,mediaPartners, winners};
